import { Grid, LinearProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FormattedMessage, useIntl } from 'react-intl';
import MainCard from 'ui-component/cards/MainCard';

const SubscriptionLimitWidget = ({ subscription }) => {
    const theme = useTheme();
    const intl = useIntl();

    const value = (subscription.nb_imported_photos / subscription.total_limit) * 100;
    return (
        <MainCard>
            <Grid container alignItems="center" spacing={1}>
                <Grid item xs={6}>
                    <Typography variant="subtitle2" align="left">
                        <FormattedMessage id={intl.formatMessage({id: 'dashboard.remaining_used_credits'})}/>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h3" align="left">
                        {/* eslint-disable-next-line */}
                        {subscription.nb_imported_photos} / {subscription.total_limit} ({value.toFixed(2)}%)
                    </Typography> 
                </Grid>
                <Grid item xs={12}>
                    <LinearProgress
                        variant="determinate"
                        value={value}
                        sx={{
                            height: 12,
                            bgcolor: value < 80 ?  theme.palette.success.light : theme.palette.error.light,
                            '& .MuiLinearProgress-bar': { bgcolor: value < 80 ?  theme.palette.success.main : theme.palette.error.main }
                        }}
                    />
                </Grid>

            </Grid>
        </MainCard>
    );
};

export default SubscriptionLimitWidget;
